<template>
  <div class="paginator-item" :class="{'paginator-item_active': active}">
    <div class="paginator-item__title">
      {{ title }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'PaginatorItem',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: Number,
      required: true
    }
  }
}
</script>
